export const BFM = 'bfms'
export const RESIDENT = 'residents'
export const CONTACT = 'contacts'
export const PROVIDER = 'providers'
export const VISITOR = 'visitors'
